import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { NavigationListProvider } from '../../providers/navigation-list/navigation-list';

import { AppConfig } from '../../config/app.config';
import { HomePage } from '../home/home';
import { AppVersion } from '@ionic-native/app-version';
import { BasketPage } from '../basket/basket';

@Component({
  templateUrl: 'menu.html'
})
export class MenuPage {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = HomePage;

  version = "";

  // navList: NavigationListProvider;

  constructor(
    public navigationList: NavigationListProvider,
    public config: AppConfig,
    public appVersion: AppVersion) {
    appVersion.getVersionNumber().then(x => this.version = x);
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    if (page.component && page.component == BasketPage) {
      this.nav.push(page.component, page.params);
    } else if (page.component) {
      this.nav.setRoot(page.component, page.params);
    } else {
      // Reset the content nav to have just this page
      // we wouldn't want the back button to show in this scenario
      page.function();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu.ts